import React, { useContext, useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    IconButton,
    FormControl,
    InputLabel,
} from "@mui/material";
import { ConstantAPISContext } from "../../../context/ConstantAPISContext";
import CaddeSokakAPI from "../../../apis/OB/Get/CaddeSokakAPI";
import CloseIcon from '@mui/icons-material/Close';
import { Form, Formik } from "formik";
import TableComponent from "../TableComponent";
/*
Propslar
props.data tablodaki verileri basmak için
props.yili
props.eglenceYeriAdi
props.gelirAciklamasi

*/
const OdemeBilgileriPopUp = (props: any) => {
    const columns = [

        { header: "Yılı", field: "yili", className: "text-center" },
        { header: "Dönem", field: "donemi", className: "text-center" },
        { header: "Son Ödeme Tarihi", field: "sonOdemeTarihi", className: "text-center" },
        { header: "Borç Nevi", field: "borcNevi", className: "text-center" },
        { header: "Adres/ Açıklama", field: "adresAciklama", className: "text-center" },
        { header: "İş Abone No", field: "isAboneNo", className: "text-center" },
        { header: "Sıra No", field: "siraNo", className: "text-center" },
        { header: "Ana Tutar", field: "anaVergi", className: "text-center" },
        { header: "Gecikme Faizi", field: "gecikmeFaizi", className: "text-center" },
        { header: "Gecikme Zammı", field: "gecikmeZammi", className: "text-center" },
        { header: "Toplam Tutar", field: "toplamTutar", className: "text-center" },
    ];


    //Formik constantları
    const initialValues = {
        //boş kalacak ihtiyaca göre kullanılabilir
    };
    return (
        <Dialog
            sx={{
                '& .MuiDialog-paper': { // Dialog'un iç kağıdı üzerinde stil uygulama
                    m: "1rem", // margin değerini sıfırla
                    maxWidth: '100%', // Maksimum genişliği %100 yap, ekranı tam kaplasın
                    width: '100%', // Genişliği %100 yap
                    maxHeight: '100vh', // Maksimum yüksekliği viewport'un %100'ü yap
                }
            }}
            fullWidth={true}
            maxWidth="xl"

            open={props.openPopup}

            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
        >
            <DialogTitle justifyContent={"space-between"} id="dialog-title">{"Ödeme Bilgileri Makbuz"}
                <IconButton
                    aria-label="close"
                    onClick={() => props.openPopup()}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme: any) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton> </DialogTitle>
            <DialogContent className="p-1 p-sm-4">                
                <TableComponent columns={columns} data={props.data}  ></TableComponent>
            </DialogContent>

        </Dialog >
    );
};

export default OdemeBilgileriPopUp;
